import {Subject} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ReloadDataService {
    mustReload: Subject<boolean> = new Subject<boolean>();
}
